module.exports = __webpack_public_path__ + "static/media/12UNCTAD15.4cf82c82.jpg";